import React, { useState, useRef, useEffect } from 'react'

export default function EndlessContainer({ ...props }) {
  const [containerWidth, setContainerWidth] = useState(null)
  const containerRef = useRef(null)

  const handleResize = () => {
    if (!containerRef.current) {
      return
    }

    const width = containerRef.current.getBoundingClientRect().width
    const spaceLeft = (window.innerWidth - width) / 2

    setContainerWidth(Math.round(width + spaceLeft))
  }

  useEffect(() => {
    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', () => handleResize)
    }
  }, [containerRef])

  return (
    <>
      <div
        className={`container${props.className ? ` ${props.className}` : ''}`}
        ref={containerRef}
      />
      <div
        className="ml-auto pl-5"
        style={{
          width: containerWidth || '100%',
        }}
      >
        {props.children}
      </div>
    </>
  )
}
